import styled from "styled-components";

export const ScopeFieldStyled = styled.div`
  .heading {
    padding-left: 16px;
  }
  .field {
    pointer-events: ${(props) => (props.isGeneralUser ? "none" : "auto")};
    padding: 16px;
  }

  textarea {
    min-height: 120px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    line-height: 150%;
    padding: 8px;
    overflow: hidden;
    box-sizing: border-box;
    font-family: Inter;
    border: 1px solid #080425 !important;
  }
`;
